import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import logo from "../assets/logo23.png";
import { Link } from "react-router-dom";

export default function Navbar({ sectionsRef }) {
  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    const navLinks = document.getElementById("navLinks");
    if (navLinks.classList.contains("show")) {
      const navbarToggler = document.querySelector(".navbar-toggler");
      navbarToggler.click();
    }
  };

  return (
    <div className="container mt-4">
      <nav
        className="navbar navbar-expand-lg px-4 py-1 custom-navbar"
        style={{
          backgroundColor: "#030712",
          // border: "1px solid rgba(255,255,255,0.2)",
          // borderRadius: "12px",
        }}
      >
        <a
          className="navbar-brand d-flex align-items-center"
          href="/"
          onClick={() => scrollToSection(sectionsRef.about)}
          >
          <img src={logo} alt="logo" style={{ width: "19%", height: "18%" }} />{" "}
          <span className="ms-2 fw-bold text-light brand-text">gupsy</span>
        </a>

        <button
          className="navbar-toggler text-white"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navLinks"
          aria-controls="navLinks"
          aria-expanded="false"
          aria-label="Toggle navigation"
          >
          <span className="navbar-toggler-icon" />
        </button>

        <div
          className="collapse navbar-collapse justify-content-end"
          id="navLinks"
          >
          <ul className="navbar-nav gap-lg-4 text-center">
            <li className="nav-item">
              <button
                className="nav-link btn text-white"
                onClick={() => scrollToSection(sectionsRef.about)}
                >
                About us
              </button>
            </li>
            <li className="nav-item">
              <button
                className="nav-link btn text-white"
                onClick={() => scrollToSection(sectionsRef.getInTouch)}
                >
                Use cases
              </button>
            </li>
            <li className="nav-item">
              <Link to="/reach-us" className="nav-link btn text-white">
    Reach us
  </Link>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
}
